import { useLang } from "../i18n/LanguageContext";
import { REVIEWS } from "../i18n/reviews";
import { SectionHead, Reveal } from "./Reveal";
import { Star } from "lucide-react";

const ReviewCard = ({ r, tagLabel, lang }) => (
  <article
    data-testid="review-card"
    className="w-[300px] sm:w-[380px] shrink-0 bg-[#F4F1EA] text-[#0D0F12] border border-[#0D0F12]/10 p-5 sm:p-6 flex flex-col hover:border-[#D96B27] transition-colors duration-300"
  >
    <div className="flex items-center gap-1" aria-label={`${r.stars}/5`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`w-4 h-4 ${i < r.stars ? "fill-[#D96B27] text-[#D96B27]" : "text-[#0D0F12]/25"}`} />
      ))}
    </div>
    <p dir="auto" className="mt-3 text-sm sm:text-[15px] leading-relaxed text-[#0D0F12]/85 flex-1">“{r.text[lang]}”</p>
    <div className="mt-4 pt-3 border-t border-[#0D0F12]/10 flex items-center justify-between gap-3">
      <div>
        <p className="font-display font-bold text-sm">{r.name}</p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-[#0D0F12]/50 mt-0.5">{r.loc}</p>
      </div>
      <span className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-[#D96B27] border border-[#D96B27]/40 px-2 py-1 whitespace-nowrap" dir="auto">
        {tagLabel}
      </span>
    </div>
  </article>
);

const Row = ({ reviews, reverse, dur, lang, tags }) => (
  <div className="marquee-hover overflow-hidden py-3">
    <div className={`marquee-track gap-4 ${reverse ? "rev" : ""}`} style={{ "--dur": dur }}>
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 gap-4 pe-4">
          {reviews.map((r, i) => (
            <ReviewCard key={i} r={r} tagLabel={tags[r.svc]} lang={lang} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

const ReviewsMarquee = () => {
  const { lang, t } = useLang();
  const rowA = REVIEWS.slice(0, 15);
  const rowB = REVIEWS.slice(15);

  return (
    <section id="recenzije" className="relative bg-[#EAE5DC] py-20 sm:py-28 overflow-hidden" data-testid="reviews-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHead eyebrow={t.reviews.eyebrow} title={t.reviews.title} subtitle={t.reviews.subtitle} />
      </div>

      <Reveal delay={0.15}>
        <p className="font-mono2 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-[#0D0F12]/50 text-center mt-8 px-4">
          {t.reviews.regionLine}
        </p>
      </Reveal>

      <div className="mt-8 space-y-4" dir="ltr">
        <Row reviews={rowA} reverse={false} dur="72s" lang={lang} tags={t.reviews.tags} />
        <Row reviews={rowB} reverse={true} dur="86s" lang={lang} tags={t.reviews.tags} />
      </div>
    </section>
  );
};

export default ReviewsMarquee;
